/* eslint-disable complexity */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import styles from "./styles.css";
import Logo from "./images/logo.svg";
import whatsApp from "./images/whatsapp.svg";
import InputMobile from "../../shared/input-mobile";
import Button from "../../shared/button";
import { mobileNumberValidator } from "../../../utils/validators/mobile-number-validator";
import InputOTPSingular from "../../shared/input-otp-singular";
import ArrowIcon from "../../shared/arrow";
import CountdownTimer from "../../shared/countdown-timer";
import { autoReadSMS } from "../../../utils/helpers/autoread-otp";
import Checkbox from "../../shared/checkbox";
import loader from "./loader.json";
const Lottie = loadable(() => import("react-lottie"), { ssr: false });
import BlackArrow from "./images/arrow-black.svg";
import { Link, useHistory } from "react-router-dom";
import { loginScreenLoad, termsOfUseCtaClick, tuCibilCtaClick } from "./tracking-constants";
import { sendCustomGaEvents } from "../../../tracking";
import { LOGIN_PAGE } from "../../../constants/login-constants";
import { TU_CIBIL_PDF } from "./constants";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { NUMBER } from "../../../constants/app-constants";
import PageLoader from "../page-loader";

// eslint-disable-next-line max-statements
const UserLogin = ({
    mobile,
    onClose = () => { },
    onChange,
    isEditible = true,
    isLoading,
    onOtpChange,
    showOtpField,
    onOtpVerify,
    otp = "",
    errorMessage,
    getOtpHandler = () => { },
    onResendClick,
    onBack = () => { },
    setOtp,
    setIsAutoFilledOTP,
    showWhatsappConsent = false,
    allowWhatsapp = false,
    onWhatsappToggle = () => { },
    customErrorText = "",
    currentPageType,
    onBackFromOtpScreen = () => { },
    onEditFromOtpScreen = () => { },
    ctaText = "GET OTP",
    mobileValidator = mobileNumberValidator,
    customHeading = "",
    showBackButton = true,
    isBottomSheetExperiment = false,
    isMobileAutoFocused = false,
    customLoginHeading = null,
    bypassMobileInput = false
}) => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: loader,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    const otpRef = useRef();
    const toggleRef = useRef();
    const mobileRef = useRef();
    const [showResendOtp, setShowResendOtp] = useState(false);
    const history = useHistory();

    useEffect(() => {
        if (showOtpField) {
            autoReadSMS((code) => {
                setOtp(code);
                setIsAutoFilledOTP(true);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showOtpField, errorMessage]);

    useEffect(() => {
        if (!!errorMessage && otpRef && otpRef.current) {
            otpRef.current.focus();
        }
    }, [errorMessage, otpRef]);

    useEffect(() => {
        if (!showOtpField) {
            if (isMobileAutoFocused && mobileRef && mobileRef.current) {
                window.setTimeout(() => {
                    mobileRef.current.focus();
                }, NUMBER.THREE_HUNDRED);
            }
            sendCustomGaEvents({
                ...loginScreenLoad,
                eventLabel: LOGIN_PAGE[currentPageType] || currentPageType
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showOtpField]);

    useEffect(() => {
        if (bypassMobileInput && mobile) {
            getOtpHandler();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bypassMobileInput]);

    const backClickHandler = () => {
        onBack();
        onBackFromOtpScreen();
    };

    const editClickHandler = () => {
        onBack();
        onEditFromOtpScreen();
    };

    const onChangeHandler = (e) => {
        onChange(e);
    };

    const getBtnDisabledState = () => {
        return !(mobileValidator(mobile));
    };

    const onCompleteTimer = () => {
        setShowResendOtp(true);
    };

    const resendOtpHandler = () => {
        setShowResendOtp(false);
        onResendClick();
    };

    const onClickCibilHandler = async () => {
        await yieldToMain();
        window.open(TU_CIBIL_PDF, "_blank");

        await yieldToMain();
        sendCustomGaEvents({
            ...tuCibilCtaClick
        });
    };

    const onClickTerms = async () => {
        await yieldToMain();
        history.push(`/cibil-consent`);

        await yieldToMain();
        sendCustomGaEvents({
            ...termsOfUseCtaClick
        });
    };

    if (bypassMobileInput && (isLoading || !showOtpField)) {
        return <PageLoader/>;
    }

    return (
        <div styleName={isBottomSheetExperiment ? "styles.phoneExpriment" : ""}>
            {
                showOtpField ?
                    <React.Fragment>
                        <div styleName="styles.loginSignupWrapper">
                            <div styleName={"styles.outer"}>
                                <div styleName={"styles.otpHeader"}>
                                    <ArrowIcon rotateBy={90} black={"BlackArrow"} onClick={backClickHandler} />
                                </div>
                                <div styleName={"styles.otpVerifySection"}>
                                    <h3 className={"text-center"}>
                                        {customHeading ? customHeading :
                                            <React.Fragment><strong>OTP</strong> Verification </React.Fragment>}
                                    </h3>
                                    <p styleName={"styles.otpSentText"}>
                                        Code sent to
                                        <strong>{mobile}</strong>
                                        {isEditible && <span onClick={editClickHandler}>Edit</span>}
                                    </p>
                                    <InputOTPSingular
                                        inputRef={otpRef}
                                        prefilledOtp={otp}
                                        onOtpChange={onOtpChange}
                                        errorMessage={errorMessage}
                                        isOTPInvalid={!!errorMessage}
                                        onOTPVerifyCallback={onOtpVerify}
                                        isLoading={isLoading}
                                        isAutoFocus={true}
                                    />
                                    <p className={"mb-0"} styleName={`styles.otpSentText styles.otpSent ${errorMessage ? "styles.errorMsg" : ""}`}>
                                        {
                                            !showResendOtp ?
                                                <React.Fragment>
                                                    <p styleName={"styles.sendOtp"}>Resend OTP in</p>
                                                    <CountdownTimer
                                                        onlyText={true}
                                                        interval={30}
                                                        onComplete={onCompleteTimer}
                                                    />
                                                    <p styleName="styles.timer">seconds</p>
                                                </React.Fragment> :
                                                <span role="button" onClick={resendOtpHandler}>
                                                    Resend OTP
                                                </span>
                                        }
                                    </p>
                                    {
                                        isLoading && <Lottie
                                            options={defaultOptions}
                                            height={40}
                                            width={200}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                    :
                    <div styleName={"styles.postInspectionLogin"}>
                        <div styleName={`styles.closeIconWrapper ${!showBackButton ? "styles.hideBackButton" : ""}`}>
                            {showBackButton && <span onClick={onClose}><img src={BlackArrow} alt="close" /></span>}
                            <img src={Logo} alt="logo" />
                        </div>

                        <div styleName={"styles.loginContent"}>

                            {customLoginHeading || <h3><strong>Log in</strong> to <br /> continue</h3>}
                            <InputMobile
                                countryCode={"91 -"}
                                placeholder="Mobile Number"
                                value={mobile}
                                onChange={onChangeHandler}
                                disabled={!isEditible}
                                inputRef={mobileRef}
                            />
                            {
                                customErrorText && <p styleName={"styles.customError"}>{customErrorText}</p>
                            }
                            {
                                showWhatsappConsent &&
                                <div styleName={"styles.wrapper"}>
                                    <div styleName={"styles.whatsAppWrapper"}>
                                        <img src={whatsApp} alt="whatsapp" />
                                        <div className={"media-body"}>
                                            <p><strong>Get instant updates</strong> <br />from CARS24 on your <strong>Whatsapp</strong></p>
                                        </div>
                                    </div>
                                    <div styleName={"styles.checkboxWrap"}>
                                        <Checkbox
                                            inputRef={toggleRef}
                                            onClickCallback={onWhatsappToggle}
                                            checkedStatus={allowWhatsapp}
                                        />
                                    </div>
                                </div>
                            }
                            <Button
                                isLoading={isLoading}
                                text={ctaText}
                                onClick={getOtpHandler}
                                disabled={getBtnDisabledState()}
                            />
                        </div>

                        <div styleName={"styles.loginFooterList"}>
                            <p>By logging in, you agree to</p>
                            <ul>
                                <li>
                                    <span onClick={onBack}>CARS24’s Privacy <Link to={"/privacy-policy-buy-cars"}>Privacy Policy</Link></span> and <span onClick={onBack}><Link to={"/terms-and-conditions"}>Terms &amp; Conditions.</Link></span>
                                </li>
                                <li>
                                    {"CARS24 NBFC’s "}
                                    <span onClick={onClickTerms} styleName="styles.link">
                                        Terms of Use
                                    </span>
                                    {" and "}<span onClick={onClickCibilHandler} styleName="styles.link">
                                        TU CIBIL Terms of Use
                                    </span>

                                </li>
                            </ul>
                        </div>
                    </div>

            }
        </div>
    );
};

UserLogin.propTypes = {
    mobile: PropTypes.any,
    onChange: PropTypes.func,
    onClose: PropTypes.func,
    isLoading: PropTypes.bool,
    getOtpHandler: PropTypes.func,
    onOtpChange: PropTypes.func,
    showOtpField: PropTypes.bool,
    onOtpVerify: PropTypes.func,
    otp: PropTypes.any,
    errorMessage: PropTypes.string,
    onResendClick: PropTypes.func,
    onBack: PropTypes.func,
    allowAutoClick: PropTypes.func,
    isEditible: PropTypes.bool,
    setOtp: PropTypes.func,
    setIsAutoFilledOTP: PropTypes.func,
    showWhatsappConsent: PropTypes.bool,
    allowWhatsapp: PropTypes.bool,
    onWhatsappToggle: PropTypes.func,
    customErrorText: PropTypes.string,
    currentPageType: PropTypes.string,
    onBackFromOtpScreen: PropTypes.func,
    onEditFromOtpScreen: PropTypes.func,
    ctaText: PropTypes.string,
    mobileValidator: PropTypes.func,
    customHeading: PropTypes.string,
    showBackButton: PropTypes.bool,
    isBottomSheetExperiment: PropTypes.bool,
    isMobileAutoFocused: PropTypes.bool,
    customLoginHeading: PropTypes.node,
    bypassMobileInput: PropTypes.bool
};

export default UserLogin;
